import React from "react";
import { Badge } from "../../ui/badge";
import { Progress } from "../../ui/progress";
import placeholder_img from "../../../assets/images/placeholder.svg";
import { AspectRatio } from "../../ui/aspect-ratio";

const LeftDonateCardContent = ({
  imgSrc,
  dayLeft,
  campaignTitle,
  amountAchieved,
  amountTarget,
  progressPercent,
  totalDonators,
  campaignTier,
}) => {
  return (
    <>
      <div className="w-full h-full flex flex-col items-center justify-center">
        <div className="relative w-full h-full overflow-hidden rounded-lg">
          <AspectRatio ratio={16 / 9} className="bg-muted">
            <img
              src={imgSrc}
              alt="Campaign"
              className="w-full h-full object-cover"
            />
          </AspectRatio>
          {campaignTier === 1 ? (
            <div className="absolute mt-1 ml-1 top-0 left-0">
              <Badge variant="white">{`Còn ${dayLeft} ngày`}</Badge>
            </div>
          ) : (
            <div className="absolute mt-1 ml-1 top-0 left-0">
              <Badge variant="white">Ủng hộ và xử lý song song</Badge>
            </div>
          )}
        </div>
        <div className="bg-white w-full px-6">
          <p className="text-lg font-bold mt-2 mb-4">{campaignTitle}</p>
          <div className="w-full flex justify-between">
            <p className="mb-2">
              Đã đạt được <b className="text-lg">{amountAchieved} VND</b>
            </p>
            <p className="text-muted-foreground">{progressPercent}%</p>
          </div>
          <Progress
            value={progressPercent}
            className="w-full bg-[#e9ecef] mb-2"
          />
          <div className="w-full flex justify-between">
            <p className="mb-2">Của mục tiêu {amountTarget} VND</p>
            <p className="text-muted-foreground">
              {totalDonators} người đã ủng hộ
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftDonateCardContent;
